// extracted by mini-css-extract-plugin
var _1 = "VersionChanges-module__active--MZInf";
var _2 = "VersionChanges-module__animateUploadProgressBarWidth--q5hMZ";
var _3 = "VersionChanges-module__animatedBackground--qd61r";
var _4 = "VersionChanges-module__bar--Rvef9";
var _5 = "VersionChanges-module__barButton--xcl1H";
var _6 = "VersionChanges-module__barContainer--IQMmg";
var _7 = "VersionChanges-module__barContent--Q0g62";
var _8 = "VersionChanges-module__changes--Hj_7u";
var _9 = "VersionChanges-module__content--zP2dC";
var _a = "VersionChanges-module__contentContainer--X_9sX";
var _b = "VersionChanges-module__contentGrid--qOG5T";
var _c = "VersionChanges-module__cyclingButtons--sOatL";
var _d = "VersionChanges-module__cyclingContainer--ScIg9";
var _e = "VersionChanges-module__cyclingLabel--IaC82";
var _f = "VersionChanges-module__footer--hJF_c";
var _10 = "VersionChanges-module__footerContainer--ECnjn";
var _11 = "VersionChanges-module__footerWaypoint--jkk3x";
var _12 = "VersionChanges-module__hide--N6Bd2";
var _13 = "VersionChanges-module__isRightPanelOpen--JzFTx";
var _14 = "VersionChanges-module__isSticky--OIBdo";
var _15 = "VersionChanges-module__muted--z5Wi0";
var _16 = "VersionChanges-module__scrollContainer--js_6o";
var _17 = "VersionChanges-module__showDivider--AhfCN";
var _18 = "VersionChanges-module__versionMeta--t3Fds";
var _19 = "VersionChanges-module__versionMetaContainer--cxpsA";
var _1a = "VersionChanges-module__wrapper--iDNgj";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "bar", _5 as "barButton", _6 as "barContainer", _7 as "barContent", _8 as "changes", _9 as "content", _a as "contentContainer", _b as "contentGrid", _c as "cyclingButtons", _d as "cyclingContainer", _e as "cyclingLabel", _f as "footer", _10 as "footerContainer", _11 as "footerWaypoint", _12 as "hide", _13 as "isRightPanelOpen", _14 as "isSticky", _15 as "muted", _16 as "scrollContainer", _17 as "showDivider", _18 as "versionMeta", _19 as "versionMetaContainer", _1a as "wrapper" }
